module.exports = __webpack_public_path__ + "img/bg.30c3d57f.png";